<template>
  <div class="rap-search">
    <div class="breadcrumbs">
      <span class="trail-begin">
        <a href="/" title="Downtown East Side" rel="home" class="trail-begin">DTES RAP</a>
      </span>
      <span class="divider">/</span>
      <span class="trail-end"> Search</span>
    </div>

    <search-base v-on:results="makeResultsView" :labels="labels">
      <template v-slot:search-scope="slotProps">
        <div class="search-scope-container">
          <search-scope
            v-model="openAccess"
            v-on:change="updateOpenAccess"
          ></search-scope>
          <i ref="openAccessHelp" class="fa fa-question-circle tooltip-trigger"></i>
        </div>
      </template>
      <template v-slot:show-and-hide-facets="slotProps">
        <button
          class="btn btn-light"
          v-on:click="updateFacetCollapse"
          id="toggle-facet"
          v-show="showFiltersBtn"
        >
          <i class="fa fa-sort-amount-desc"></i>&nbsp;{{ facetLabel }} Filters
        </button>
      </template>
      <template v-slot:results-slot="slotProps">
        <rap-results
          v-for="r in slotProps.results"
          :key="r._id"
          :r="r"
          :mediaTypeIconMap="mediaTypeIconMap"
        ></rap-results>
      </template>
    </search-base>
  </div>
</template>

<script>
// import base search component from lit-discovery
import searchBase from "lit-discovery/vue/search-base.vue";
import rapResults from "./components/_rap-results.vue";
import searchScope from "./components/_search-scope.vue";
import Tooltip from "tooltip.js";

export default {
  components: {
    "search-base": searchBase,
    "rap-results": rapResults,
    "search-scope": searchScope,
  },
  data() {
    return {
      total: 0,
      isCollapsed: false,
      resultsView: "rap-results",
      showFiltersBtn: false,
      labels: {
        queryPlaceholder: "Search items"
      },
      openAccess:
        this.$route.query.hasOwnProperty("nested_term") &&
        this.$route.query["nested_term"] &&
        this.$route.query["nested_term"].includes("access.type.raw,open")
          ? true
          : false,
    };
  },
  computed: {
    facetLabel: function () {
      return this.isCollapsed ? "Show" : "Hide";
    },
    showFiltersBtn(){
      return this.$route.query["q"]
      // return false;
    }
  },
  beforeMount() {
    const el = document.getElementById("page-config");
    const data = JSON.parse(el.dataset.props);
    this.mediaTypeIconMap = data.media_type_icon_map;
  },
  mounted() {
    if (this.$router.currentRoute.path === "/advanced") {
      this.isCollapsed = false;
    } else {
      this.isCollapsed = true;
  }

    // setSearchPlaceholder();
    this.createOpenAccessHelpTooltip();
  },
  methods: {
    createOpenAccessHelpTooltip: function () {
      new Tooltip(this.$refs.openAccessHelp, {
        placement: "right",
        title: "Free use refers to open access or public resources",
        trigger: "hover",
      });
    },
    updateOpenAccess: function () {
      this.openAccess = !this.openAccess;
    },
    updateFacetCollapse: function () {
      this.isCollapsed = !this.isCollapsed;
    },
    makeResultsView: function (total) {
      let $self = this;
      $self.total = total;
    },
  },
  watch: {
    isCollapsed: function () {
      this.$eventBus.emit("toggle-facet", this.isCollapsed);
    },
    $route(to, from) {
      if (from.path === "/" && to.path === "/advanced") {
        this.isCollapsed = false;
      } else if (from.path === "/advanced" && to.path === "/") {
        this.isCollapsed = true;
      }
    },
  },
};
</script>
